import { MAX_NUMBER_AMOUNT } from "constants/form";

export const MAX_SPLIT_PAYMENTS_BANK_ACCOUNTS = 3;
export const MIN_PERCENTAGE_AMOUNT = 1;
export const MAX_PERCENTAGE_AMOUNT = 99;
export const MIN_MONETARY_AMOUNT = 1;
export const MAX_MONETARY_AMOUNT = MAX_NUMBER_AMOUNT;
